import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actGetListCheckInEmployeeSuccess,
  actGetListCheckInEmployeeFailed,
  MASTER_GET_LIST_CHECK_IN_EMPLOYEE,
} from '../../actions/report-check-in-employee'
import { apiGetListCheckInEmployee } from '../../apis/report-check-in-employee'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetList(action) {
  try {
    const response = yield call(apiGetListCheckInEmployee, action?.payload)

    if (response?.statusCode === 200) {
      const data = {
        data: response.data,
      }

      yield put(actGetListCheckInEmployeeSuccess(data))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actGetListCheckInEmployeeFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchGetList() {
  yield takeLatest(MASTER_GET_LIST_CHECK_IN_EMPLOYEE, doGetList)
}
